import type { TourDefinition } from './types';

/**
 * Global tour registry. Tours are registered once at module load time (see
 * each feature's `tours.ts` file once we start adding them) and looked up by
 * id when the user starts one.
 *
 * Keeping the registry out of React state means tour definitions can live
 * alongside the feature they describe without forcing the provider to know
 * about every feature directly.
 */
const tours = new Map<string, TourDefinition>();

export function registerTour(tour: TourDefinition): void {
  if (tours.has(tour.id) && import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.warn(`[tours] Overwriting existing registration for "${tour.id}"`);
  }
  tours.set(tour.id, tour);
}

export function getTour(id: string): TourDefinition | undefined {
  return tours.get(id);
}

export function getAllTours(): TourDefinition[] {
  return Array.from(tours.values());
}
